import { RouteObject } from 'react-router';

import { Profile } from 'features/user/pages';

import { LegalThanksContainer } from './components/LegalEntity/containers/LegalThanksContainer';
import { LegalErrorContainer } from './components/LegalEntity/containers/LegalErrorContainer';
import { ProfileDeleteContainer } from './components/DeleteAccount/containers/ProfileDeleteContainer';

const routes: RouteObject[] = [
    {
        path: 'profile',
        element: <Profile />,
        children: [{ path: 'delete', element: <ProfileDeleteContainer /> }],
    },
    {
        path: 'legal-success',
        element: <LegalThanksContainer />,
    },
    {
        path: 'legal-error',
        element: <LegalErrorContainer />,
    },
];

export default routes;
